<template>
  <PageWrapper :maxWidth="5000">
    <template #left-header>
      <div v-if="companyLogo" class="flex-center">
        <b-img-lazy
          :src="companyLogo"
          :onerror="`this.src='${defaultLogo}'`"
          width="40"
          height="auto"
        />
      </div>
    </template>
    <b-row class="margin-0 margin-top-16">
      <b-col cols="12" class="padding-0">
        <Tabs
          ref="tabsReference"
          class=""
          :tabs="tabs"
          :isDesktopTabs="true"
          @getCurrentTab="getCurrentTab"
        >
          <template #extra-options>
            <div class="flex gap-8">
              <Button
                variant="primary"
                :text="$lang.selectParvandeh"
                contentClass="justify-content-center"
                class="width-percent-100 margin-bottom-16"
                @click="handleOpenParvandehListPin"
              />
              <Button
                v-if="isParvandehSelected"
                variant="outline-primary"
                :text="$lang.dataExport"
                contentClass="justify-content-center"
                class="width-percent-100 margin-bottom-16"
                rightIcon="arrow-down"
                :loading="dataExportLoading"
                @click="handleDataExport"
              />
            </div>
          </template>
          <template #tab-0>
            <Alert
              v-if="!isParvandehSelected"
              :text="$lang.selectParvandehMessage"
              class="margin-bottom-16"
            />
            <TabContent0 />
          </template>
          <template #tab-1>
            <TabContent1 />
          </template>
          <template #tab-2>
            <TabContent2 />
          </template>
          <template #tab-3>
            <TabContent2 />
          </template>
          <template #tab-4>
            <TabContent2 />
          </template>
          <template #tab-5>
            <TabContent2 />
          </template>
          <template #tab-6>
            <TabContent2 />
          </template>
        </Tabs>
      </b-col>
    </b-row>
    <SelectedParvandehListPin
      :visible="isParvandehListPin"
      @handleClose="handleCloseParvandehListPin"
      @handleSubmit="handleSubmit"
    />
  </PageWrapper>
</template>

<script>
import { PageWrapper, Tabs, Alert } from "@/components/re-design";
import { Button } from "@/components/re-design/forms";
import { TabContent0, TabContent1, TabContent2 } from "./tabs";
import SelectedParvandehListPin from "./parvandeh/SelectedParvandehListPin.vue";
import useServices from "./useServices";
import { has, includes, pathOr } from "ramda";
import { computed, onMounted, provide, ref } from "vue";
import { generateConfig, generateError, toastAlert } from "@/shared/utils";
import {
  getCompetencyWashupScores,
  getDashboardReport,
  getDashboardReportTypes,
  getSummaryParvandeh,
  summaryParvandehExport,
} from "@/modules/report/services/dashboard-services";
export default {
  components: {
    PageWrapper,
    Tabs,
    Alert,
    Button,
    TabContent0,
    TabContent1,
    TabContent2,
    SelectedParvandehListPin,
  },
  setup() {
    const defaultLogo = generateConfig(["images", "tinyLogo"]);

    // get methods of hook
    const {
      getMergedItems,
      generateParvandehQueryString,
      generateItemsOfStorage,
    } = useServices();

    const isParvandehSelected = computed(() => {
      const items = getMergedItems();
      return !!items.length;
    });

    const companyLogo = ref("");
    const allowTabs = ref([]);
    const getDashboardReportTypesData = async () => {
      try {
        const queryString = generateParvandehQueryString();
        const response = await getDashboardReportTypes(queryString);
        const { resAllowTabs, resCompanyLogo } = response;

        companyLogo.value = resCompanyLogo;
        allowTabs.value = resAllowTabs;
      } catch (error) {
        generateError(error);
      }
    };
    const tabs = computed(() => {
      const allTabs = [
        {
          icon: "view-dashboard-outline",
          text: "خلاصه‌ی مدیریتی",
          description:
            "به صفحه نتایج ارزیابی خوش آمدید! در اینجا مروری بر ارزیابی‌های اخیر ما، از جمله داده‌های مربوط به مراکز ارزیابی، آزمون‌های روان‌سنجی، و توصیه‌هایی برای توسعه پیدا خواهید کرد. همچنین می توانید افراد مختلف را با هم مقایسه کنید. لطفاً این اطلاعات را به دقت بررسی کنید و از آن برای حمایت و راهنمایی اعضای تیم خود در جهت دستیابی به اهدافشان استفاده کنید. از مشارکت شما در این فرآیند سپاسگزاریم.<br>در این بخش می‌تواند فایل گزارش‌ ارزیابی‌های انجام شده را دانلود نمایید.",
          firstTabTitle: "",
          algorithmName: "tab-one",
          isActive: false,
          show: true,
        },
        {
          icon: "chart-box-outline",
          text: "نتایج ارزیابی شایستگی‌ها",
          description:
            "این صفحه به گونه ای طراحی شده است که یک نمای کلی از کل نمرات و جزئیات نمرات در هر تمرین از ارزیابی های اخیر مرکز ارزیابی ما را در اختیار شما قرار دهد.<br>کانون ارزیابی ما طیف وسیعی از رفتارهای مرتبط با ماموریت‌های کارکنان را ارزیابی می‌کند. در این صفحه، عملکرد هر تمرین شامل مهارت ها و رفتارهای ارزیابی شده و نمرات هر دسته را مشاهده خواهید کرد. از این اطلاعات می توان برای درک حوزه های قوت و فرصت های توسعه در مهارت ها و رفتارهای ارزیابی شده استفاده کرد.<br>ما بر این باوریم که این بازخورد برای کمک به شرکت کنندگان و مدیران آنها در درک مهارت ها و رفتارهای ارزیابی شده و ارائه بازخورد و مربیگری هدفمند برای کمک به بهبود مهارت ها و رفتارها در صورت نیاز ضروری است",
          firstTabTitle: "بازده انتظاری",
          algorithmName: "tab-two",
          isActive: false,
          show: true,
        },
        {
          icon: "chart-box-outline",
          text: "آزمون واتسون",
          description:
            "آزمون واتسون گلیزر توانایی‌های تفکر انتقادی را که برای موفقیت در بسیاری از مشاغل ضروری هستند، ارزیابی می‌کند.<br>تفکر انتقادی شامل تجزیه و تحلیل، ارزیابی و ترکیب اطلاعات برای تصمیم گیری آگاهانه و حل مشکلات است.<br>این صفحه به منظور ارائه یک نمای کلی از نتایج آزمون، از جمله نمره کلی و نمرات در هر بخش از آزمون، طراحی شده است. در این صفحه، عملکرد هر بخش از آزمون واتسون گلیزر، از جمله نمره و نمودار آن را خواهید دید.<br>با تمرکز بر توسعه مهارت های تفکر انتقادی در کنار استعداد شناسایی شده، افراد می توانند به پتانسیل کامل خود برسند و در شغل خود به موفقیت برسند.<br>صفحه ما یافته‌های  ارزشمندی در مورد توانایی‌های تفکر انتقادی ارائه می‌کند و می‌تواند افراد را در سفرشان برای تبدیل شدن به متفکران انتقادی مؤثرتر راهنمایی کند",
          firstTabTitle: "توانایی ادراکی",
          algorithmName: "watson",
          isActive: false,
          show: true,
        },
        {
          icon: "chart-box-outline",
          text: "آزمون واتسون",
          description:
            "آزمون واتسون گلیزر توانایی‌های تفکر انتقادی را که برای موفقیت در بسیاری از مشاغل ضروری هستند، ارزیابی می‌کند. تفکر انتقادی شامل تجزیه و تحلیل، ارزیابی و ترکیب اطلاعات برای تصمیم گیری آگاهانه و حل مشکلات است.<br>این صفحه به منظور ارائه یک نمای کلی از نتایج آزمون، از جمله نمره کلی و نمرات در هر بخش از آزمون، طراحی شده است. در این صفحه، عملکرد هر بخش از آزمون واتسون گلیزر، از جمله نمره و نمودار آن را خواهید دید.<br>با تمرکز بر توسعه مهارت های تفکر انتقادی در کنار استعداد شناسایی شده، افراد می توانند به پتانسیل کامل خود برسند و در شغل خود به موفقیت برسند.<br>صفحه ما یافته‌های  ارزشمندی در مورد توانایی‌های تفکر انتقادی ارائه می‌کند و می‌تواند افراد را در سفرشان برای تبدیل شدن به متفکران انتقادی مؤثرتر راهنمایی کند.<br><br>در این آزمون نمره منفی در تصحیح نتایج لحاظ شده است.",
          firstTabTitle: "توانایی ادراکی",
          algorithmName: "watson_negative",
          isActive: false,
          show: true,
        },
        {
          icon: "chart-box-outline",
          text: "آزمون توانایی ادراک عمومی",
          description:
            "آزمون هوش مدیریتی موسسه ساویل اسسمنت یک ابزار ارزیابی پیشرو است که توانایی‌های تفکر انتقادی و تصمیم‌گیری افراد را که برای رهبری و مدیریت مؤثر ضروری است، اندازه‌گیری می‌کند.<br>آزمون هوش مدیریتی سویفت برای ارزیابی توانایی فرد در تصمیم گیری سریع و دقیق در موقعیت‌های پیچیده و پویا طراحی شده است.<br>در این صفحه، نمرات هر بخش از آزمون را خواهید دید که بازخورد ارزشمندی در مورد مهارت‌های تفکر انتقادی و تصمیم گیری شرکت‌کننده ارائه می دهد.<br>با تمرکز بر توسعه تفکر انتقادی و مهارت‌های تصمیم‌گیری، افراد می‌توانند به رهبران یا مدیران اثربخش‌تری تبدیل شوند که آنها را برای عبور از چالش‌ها و دستیابی به اهداف سازمان مجهزتر می‌سازد.",
          firstTabTitle: "بازده انتظاری",
          algorithmName: "IBF",
          isActive: false,
          show: true,
        },
        {
          icon: "chart-box-outline",
          text: "آزمون هوش مدیریتی",
          description: "",
          firstTabTitle: "بازده انتظاری",
          algorithmName: "management_intelligence",
          isActive: false,
          show: true,
        },
        {
          icon: "chart-box-outline",
          text: "آزمون نئو",
          description: "",
          firstTabTitle: "بازده انتظاری",
          algorithmName: "neo",
          isActive: false,
          show: true,
        },
      ];
      return allTabs.filter((tab) => {
        let condition = true;

        if (has("algorithmName", tab)) {
          condition = includes(tab.algorithmName, allowTabs.value);
        }
        return condition;
      });
    });

    const parvandehItems = ref([]);
    // get parvandeh data
    const loading = ref(false);
    const getParvandehData = async () => {
      if (!isParvandehSelected.value) return;
      try {
        loading.value = true;
        const queryString = generateParvandehQueryString();
        const response = await getSummaryParvandeh(queryString);
        const { items } = response;
        parvandehItems.value = generateItemsOfStorage(
          items,
          parvandehItems.value
        );
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };
    const getWashupScoresData = async () => {
      try {
        loading.value = true;
        const queryString = generateParvandehQueryString();
        const response = await getCompetencyWashupScores(queryString);
        const { items } = response;
        parvandehItems.value = generateItemsOfStorage(
          items,
          parvandehItems.value
        );
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };
    const averageParentData = ref([]);
    const averageChildData = ref([]);
    const getDashboardReportData = async (algorithmName) => {
      try {
        loading.value = true;
        const extraQueryStrings = { algorithm_name: algorithmName };
        const queryString = generateParvandehQueryString(extraQueryStrings);
        const response = await getDashboardReport(queryString);
        const { items, avgParentData, avgChildData } = response;
        parvandehItems.value = generateItemsOfStorage(
          items,
          parvandehItems.value
        );
        averageParentData.value = avgParentData;
        averageChildData.value = avgChildData;
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      if (isParvandehSelected.value) {
        Promise.all([getParvandehData(), getDashboardReportTypesData()]);
      }
    });

    const tabsReference = ref(null);
    const handleSubmit = () => {
      parvandehItems.value = [];
      tabsReference.value.handleSelectTab(0);
      getDashboardReportTypesData();
      getParvandehData();
    };

    // handle parvandeh list pin
    const isParvandehListPin = ref(false);
    const handleOpenParvandehListPin = () => {
      isParvandehListPin.value = true;
    };
    const handleCloseParvandehListPin = () => {
      isParvandehListPin.value = false;
    };

    const currentTab = ref(null);
    const getCurrentTab = (item) => (currentTab.value = item);
    provide(
      "CURRENT_TAB",
      computed(() => currentTab.value || tabs.value[0])
    );

    const isDataExport = computed(() => {
      const algorithmName = pathOr(null, ["algorithmName"], currentTab.value);
      return algorithmName && !includes(algorithmName, ["tab-one", "tab-two"]);
    });

    // handle data export
    const dataExportLoading = ref(false);
    const handleDataExport = async () => {
      try {
        dataExportLoading.value = true;
        const queryString = generateParvandehQueryString();

        const response = await summaryParvandehExport(queryString);
        const { link, message } = response;

        toastAlert(message);
        window.open(link, "_blank");
      } catch (error) {
        generateError(error);
      } finally {
        dataExportLoading.value = false;
      }
    };

    // handle provide data
    provide(
      "LOADING",
      computed(() => loading.value)
    );
    provide(
      "PARVANDEH_ITEMS",
      computed(() => parvandehItems.value)
    );
    provide(
      "AVERAGE_PARENT_DATA",
      computed(() => averageParentData.value)
    );
    provide(
      "AVERAGE_CHILD_DATA",
      computed(() => averageChildData.value)
    );
    provide("GET_PARVANDEH_DATA", getParvandehData);
    provide("GET_WASHUP_SCORES_DATA", getWashupScoresData);
    provide("GET_DASHBOARD_REPORT_DATA", getDashboardReportData);

    // return data to be used in template
    return {
      tabs,
      defaultLogo,
      isParvandehSelected,
      isParvandehListPin,
      handleOpenParvandehListPin,
      handleCloseParvandehListPin,
      getParvandehData,
      getCurrentTab,
      companyLogo,
      handleSubmit,
      handleDataExport,
      dataExportLoading,
      isDataExport,
      tabsReference,
    };
  },
};
</script>
